/* eslint-disable react/prop-types */
import React from "react"; // React Stuff
//TimeRendering
import Moment from "react-moment";
//Packages
import axios from "axios";
import { Col, Row, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

const ClassWaitingList = (props) => {
  //Revoke the Waiting List Offer
  const revokeWaitingList = async (_id) => {
    const revokeRequest = await axios.put(
      `/api/admin/manage/revoke_waiting`,
      { _id },
      {
        withCredentials: true,
      }
    );
    if (revokeRequest.status === 200) {
      props.setSubmitClicked(false);
      props.fetchNewData();
      return props.setSuccessMessage("Offer was revoked.");
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  //Make the Waiting List Offer
  const allowSubscribe = async (_id) => {
    const allowRequest = await axios.put(
      `/api/admin/manage/waiting_subscribe`,
      { _id },
      {
        withCredentials: true,
      }
    );
    if (allowRequest.status === 200) {
      props.setSubmitClicked(false);
      props.fetchNewData();
      return props.setSuccessMessage("Offer was successfully made");
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  //Delete the Waiting List Entry
  const cancelWaitingList = async (_id) => {
    const deleteRequest = await axios.delete(
      `/api/admin/manage/waiting_list_delete`,
      { data: { _id } },
      {
        withCredentials: true,
      }
    );
    if (deleteRequest.status === 200) {
      props.setSubmitClicked(false);
      props.fetchNewData();
      return props.setSuccessMessage("Waiting list entry was deleted.");
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        {" "}
        <h3 className='mt-4'>Waiting List</h3>
        {props.data.WaitingList.length > 0 ? (
          <Table striped bordered hover responsive className='text-center'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Offer the Space?</th>
                <th>Remove?</th>
              </tr>
            </thead>
            <tbody>
              {props.data.WaitingList.map((WaitingListEntry) => (
                <tr key={WaitingListEntry._id}>
                  <td className='align-self-center align-middle'>
                    <small>
                      <Link to={`/admin/customer-list/${WaitingListEntry.SystemUserID}`}>
                        {WaitingListEntry.Participant_Name}
                      </Link>
                      <br />
                      Since <Moment format='DD MMMM YYYY'>{WaitingListEntry.OnListSince}</Moment>
                    </small>
                  </td>

                  <td className='align-self-center align-middle'>
                    {WaitingListEntry.Status === "Offered" ? (
                      <>
                        <Button
                          variant='info'
                          size='sm'
                          type='submit'
                          disabled={props.submitClicked}
                          onClick={(e) => revokeWaitingList(WaitingListEntry._id, e)}
                        >
                          Revoke
                        </Button>
                        <Button
                          variant='secondary'
                          size='sm'
                          type='submit'
                          className='ms-2'
                          disabled={props.submitClicked}
                          onClick={(e) => allowSubscribe(WaitingListEntry._id, e)}
                        >
                          Resend
                        </Button>
                      </>
                    ) : WaitingListEntry.Status === "Expired" ? (
                      <span>This Offer Has Been Expired</span>
                    ) : (
                      <Button
                        variant='secondary'
                        size='sm'
                        type='submit'
                        disabled={props.submitClicked}
                        onClick={(e) => allowSubscribe(WaitingListEntry._id, e)}
                      >
                        Allow This Subscriber
                      </Button>
                    )}
                  </td>
                  <td className='align-self-center align-middle'>
                    <Button
                      variant='secondary'
                      size='sm'
                      type='submit'
                      disabled={props.submitClicked}
                      onClick={(e) => cancelWaitingList(WaitingListEntry._id, e)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>Waiting list is empty...</p>
        )}
      </Col>
    </Row>
  );
};

export default ClassWaitingList;
